module.exports = __webpack_public_path__ + "static/media/bg-home.4aac323c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg-home.png
// module id = 312
// module chunks = 0